/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import 'core-js/stable'
import 'regenerator-runtime/runtime'
require('@rails/ujs').start()

import './application.css'
import 'components' // SIDE LOAD view components

import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

const application = Application.start()
// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.
const context = require.context('javascript/controllers', true, /\.js$/)
application.load(definitionsFromContext(context))


// NOTE: FOR VIEW COMPONENTS AS STIMULUS CONTROLLERS (remove import above & delete app/components/index.js)
// Controller files must be renamed *_controller.js
// const context = require.context('javascript/controllers', true, /\.js$/)
// const context_components = require.context('components', true, /_controller.js$/)

// application.load(
//   definitionsFromContext(context).concat(definitionsFromContext(context_components))
// )

